import { useMemo, useCallback, useState } from 'react'

import { useQuery } from '@apollo/client'

import { useRadar, Modification, RadarType } from '../../api/radar'
import { useAdmins } from '../../api/admins'
import { gql } from '../../gql'

import Page from '../../components/Page'
import RadarItem from './RadarItem'
import EmptyList from '../../components/EmptyList'
import { RadarFilterBar, RadarStatType } from './RadarFilter'
import { useAdmin } from '../../providers/AdminProvider'
import DropdownList from '../../components/DropdownList'
import { ListRadarsQuery, Radar } from '@/gql/graphql'

const USER_ID_SARA = 1006
const USER_ID_MONI = 1004
const USER_ID_BARNA = 1000

// TODO: össze lehetne vonni a RadarItem-mel
const filter_statuses = [
  { id: 'NEW', title: 'Új' },
  { id: 'IN_PROGRESS', title: 'Folyamatban' },
  { id: 'PROBLEMS', title: 'Problémás' },
  { id: 'DONE', title: 'Készen van' },
  { id: 'APPROVED', title: 'Jóváhagyva' },
]

const getFilterRole = (admin_id: number) => {
  console.log('admin_id = ', admin_id)
  const mapping = {
    '1004': 'DONE',
    '1006': 'NEW',
    '1000': 'NEW', // APPROVED
  }
  return mapping[String(admin_id)]
}

const createStat = (radars: RadarType[], status: string, user_id: number) => {
  const stat: RadarStatType[] = []

  for (const radar of radars) {
    if (radar.digest_status === status && radar.assigned_to === user_id) {
      const title = `${radar.issue_year}/${radar.issue_number}`
      const statItem = stat.find((item) => item.issue_title === title)
      if (statItem) {
        statItem.new_nums += 1
      } else {
        stat.push({
          issue_title: title,
          new_nums: 1,
        })
      }
    }
  }

  return stat
}

const journalFilter = (journal: string, status: string) => {
  return (radar: RadarType) => {
    const title = `${radar.issue_year}/${radar.issue_number}`
    const otherConditions =
      radar.digest_status === status || radar.isModified == Modification.Modified
    return !journal ? true : title === journal && otherConditions
  }
}

const RadarFilterRow = ({
  name,
  value,
  items,
  onSelect,
  onFilter,
}: {
  name: string
  value: string
  items: RadarStatType[]
  onSelect: (value: string, name: string) => void
  onFilter: (value: string) => void
}) => {
  //const [value, setValue] = useState<string>(initValue)

  return (
    <div className="block w-11/12 max-w-3xl">
      Számláló:
      <DropdownList name={name} value={value} list={filter_statuses} onChange={onSelect} />
      <RadarFilterBar issues={items} onSelect={onFilter} />
    </div>
  )
}

const RadarsPage = () => {
  const { id: admin_id, adminName, role } = useAdmin()
  const { radars, isLoading, isModified, updateRadarItem, saveRadarItems, saveRadar } = useRadar()
  const { admins } = useAdmins()
  const [filter, setFilter] = useState<string>('NEW')
  const [journal, setJournal] = useState<string>()

  const _admins = useMemo(() => {
    return admins.map((admin: any) => ({
      id: admin.id,
      title: admin.name,
    }))
  }, [admins])

  const _stat: RadarStatType[] = createStat(radars, filter, USER_ID_SARA)
  const _radars: RadarType[] = radars.filter(journalFilter(journal, filter))

  const handleChange = useCallback((id: number, value: any, name: string) => {
    console.log(`updateRadarItem: ${id} - ${value} - ${name}`)
    updateRadarItem(id, {
      [name]: value,
    })
  }, [])

  const handleSave = (id: number) => {
    return saveRadar(id)
  }

  const handleStatusSelected = (status: string) => {
    setJournal(undefined)
    setFilter(status)
  }

  return (
    <Page
      actions={[
        ...(false && isModified == Modification.Modified
          ? [
              {
                title: 'Mentés',
                onClick: () => {
                  saveRadarItems()
                },
              },
            ]
          : []),
      ]}
    >
      <div>
        {!isLoading ? (
          radars.length > 0 ? (
            <ul className="flex flex-col items-center">
              <RadarFilterRow
                name="radar_filter"
                value={filter}
                onSelect={handleStatusSelected}
                onFilter={() => {}}
                items={_stat}
              />
              {_radars.map((item) => (
                <RadarItem
                  value={item}
                  admins={_admins}
                  open={false}
                  onChange={handleChange}
                  onSave={handleSave}
                />
              ))}
            </ul>
          ) : (
            <div className="mx-auto w-5/6">
              <EmptyList />
            </div>
          )
        ) : (
          'Loading...'
        )}
      </div>
    </Page>
  )
}

export default RadarsPage
